import type {
    Pagination,
    StandardDrinkRecipeItem,
} from '@barboxx/models/types';

import { api } from '../../api';

const rootPath = 'standard-drinks/recipe-items';

export function getStandardDrinkRecipeItems(
    query: StandardDrinkRecipeItem.SearchQuery
) {
    return api.get<Pagination<StandardDrinkRecipeItem>>(rootPath, query);
}

export function getStandardDrinkRecipeItem(id: number) {
    return api.get<StandardDrinkRecipeItem.DetailsResponse>(
        `${rootPath}/${id}`,
        undefined
    );
}

export function postStandardDrinkRecipeItem(
    data: StandardDrinkRecipeItem.CreateRequest
) {
    return api.post<StandardDrinkRecipeItem>(rootPath, data);
}

export function putStandardDrinkRecipeItem(
    id: number,
    data: StandardDrinkRecipeItem.UpdateRequest
) {
    return api.put<StandardDrinkRecipeItem>(`${rootPath}/${id}`, data);
}

export function deleteStandardDrinkRecipeItem({
    id,
}: StandardDrinkRecipeItem.DeleteRequest) {
    return api.delete(`${rootPath}/${id}`, undefined);
}
